import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').EmailChannelDataModel>} */

var EMAIL_CHANNEL_DATA_TYPE = {
  data: {
    url: '/backend/queues?queueType=email',
    itemUrl: '/backend/queues?queueType=email&name={id}',
    dataKey: 'emailChannel',
    idKeyProp: 'Name',
    onBeforeRequest: function onBeforeRequest(options, request, data) {
      if (request.type === 'updateItem') {
        var EnableTracking = data.EnableTracking,
            rest = _objectWithoutProperties(data, ["EnableTracking"]);

        return _objectSpread({}, request, {
          data: _objectSpread({}, rest, {
            EnableTracking: undefined,
            TrackEngagement: EnableTracking,
            TrackRead: EnableTracking,
            TrackWebCampaign: EnableTracking
          })
        });
      }

      return request;
    },
    onAfterResponse: function onAfterResponse(options, request, responseBody) {
      if (request.type === 'loadItem') {
        var TrackEngagement = responseBody.TrackEngagement,
            TrackRead = responseBody.TrackRead,
            TrackWebCampaign = responseBody.TrackWebCampaign,
            rest = _objectWithoutProperties(responseBody, ["TrackEngagement", "TrackRead", "TrackWebCampaign"]);

        return _objectSpread({}, rest, {
          EnableTracking: TrackEngagement && TrackRead && TrackWebCampaign
        });
      }

      return responseBody;
    }
  },
  placeholders: {
    label: function label(data) {
      return 'Default Email Channel';
    },
    type: function type() {
      return 'email channel';
    },
    icon: function icon() {
      return 'email';
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.Name
      });
    }
  }] // contextMenu: [],

};
export default EMAIL_CHANNEL_DATA_TYPE;